import type * as Types from '../../types';

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import document from './eatDestroySessionMutation.gql';
import { EatSessionFragmentDoc } from '../../fragments/eat/EatSessionFragment.generated';
import type * as ApolloReactCommon from '~/lazy_apollo/client';
import * as ApolloReactHooks from '~/lazy_apollo/client';
const defaultOptions = {} as const;
export type EatDestroySessionMutation_destroySession_Session_user_User = {
  __typename: 'User',
  id: number,
  avatarUrl?: string | null,
  displayName: string,
  email?: string | null,
  firstName?: string | null
};

export type EatDestroySessionMutation_destroySession_Session = {
  __typename: 'Session',
  id: string,
  user?: EatDestroySessionMutation_destroySession_Session_user_User | null
};

export type EatDestroySessionMutation_Mutation = {
  __typename?: 'Mutation',
  destroySession?: EatDestroySessionMutation_destroySession_Session | null
};


export type EatDestroySessionMutationVariables = Types.Exact<{ [key: string]: never; }>;


export type EatDestroySessionMutation = EatDestroySessionMutation_Mutation;


export const EatDestroySessionDocument = /*#__PURE__*/ document as unknown as DocumentNode<EatDestroySessionMutation, EatDestroySessionMutationVariables>;

export type EatDestroySessionMutationFn = ApolloReactCommon.MutationFunction<EatDestroySessionMutation, EatDestroySessionMutationVariables>;

/**
 * __useEatDestroySessionMutation__
 *
 * To run a mutation, you first call `useEatDestroySessionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEatDestroySessionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [eatDestroySessionMutation, { data, loading, error }] = useEatDestroySessionMutation({
 *   variables: {
 *   },
 * });
 */
export function useEatDestroySessionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EatDestroySessionMutation, EatDestroySessionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EatDestroySessionMutation, EatDestroySessionMutationVariables>(EatDestroySessionDocument, options);
      }
export type EatDestroySessionMutationHookResult = ReturnType<typeof useEatDestroySessionMutation>;
export type EatDestroySessionMutationResult = ApolloReactCommon.MutationResult<EatDestroySessionMutation>;
export type EatDestroySessionMutationOptions = ApolloReactCommon.BaseMutationOptions<EatDestroySessionMutation, EatDestroySessionMutationVariables>;